import EditProfileModal from "@/apps/common/components/EditProfileModal";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FeatherIcons from "feather-icons-react";
import { api } from "@/apps/common/api-client";
import { LegacyUserType } from "@/apps/common/api-client/api-client.types";
import { useAuthStore } from "@/apps/common/store/useAuthStore";
import { Button, Spinner, Form, Modal } from "react-bootstrap";
import { useRequest } from "ahooks";
import { useNavigate } from "react-router-dom";





const TermsOfUse = () => {

  const [showAcceptTermsUseModal, setShowAcceptTermsUseModal] = useState(false);
  const [contractsToUpdate, setContractsToUpdate] = useState<string[]>([])
  const [checked, setChecked] = useState(false);
  const { user } = useAuthStore();
  const navigate = useNavigate();


  const checkContracts = async () => {

    //console.debug(`check if latest signed contracts exists`)
    if (user?.id) {
      const contracts = await api.contracts.checkForLatestUnsignedContracts(user?.id, ["privacy-policy", "terms-of-use"])
      if (contracts.length > 0) {
        setContractsToUpdate(contracts)
        setShowAcceptTermsUseModal(true)
      }
      else{
        navigate('/dashboard')
      }
    }

   

  }

  useEffect(() => {
    checkContracts()
  }, []);

  const onCloseModal = () => {
    setShowAcceptTermsUseModal(false);
  };

  const handleChange = (e: any) => {
    setChecked(e.target.checked);
  };

  const signContracts = async () => {
    //console.debug(`Signing contracts - ${JSON.stringify(contractsToUpdate)}`)
    contractsToUpdate.forEach((slug)=>{
       api.contracts.signContract(slug);
    })
    // await api.contracts.signContract("privacy-policy");
    // await api.contracts.signContract("terms-of-use");
    navigate("/dashboard");

  }

  return (
    <>
      {showAcceptTermsUseModal ? (
        <Modal
          show={showAcceptTermsUseModal}
        >
          <Modal.Header>
            Terms Of Use and Privacy Policy Details Update(s)
          </Modal.Header>
          <Modal.Body>
            <p className="fs-4 fw-bolder"> We have updated our Privacy Policy and Terms Of Use details.</p>
            <Form>
              <Form.Check
                type="checkbox"
                id="accept-contracts"
                label={<span className="fs-10">
                  Please check this box to acknowledge that you have read and
                  accept the{" "}
                  <a
                    href="https://skylerhealth.com/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>{" "}
                  and the{" "}
                  <a href="https://skylerhealth.com/tou" target="_blank">
                    Terms of Use
                  </a>
                </span>}
                checked={checked}
                onChange={handleChange}
              >
              </Form.Check>
            </Form>
            <div className="d-flex justify-content-center m-3">
              <Button disabled={!checked} onClick={() => { signContracts() }}>Accept</Button>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};

export default TermsOfUse;
